// @ts-nocheck
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent } from '@lbca-shared/button';
import { IconComponent } from '@lbca-shared/icon';
import cepPromise from 'cep-promise';
import { waitingTimer } from '../../../../helpers/_old_helpers/animate';
import { InputRadioComponent } from '../input-radio/input-radio.component';
import { InputTextComponent } from '../input-text/input-text.component';
import { SelectComponent } from '../select/select.component';
import FieldsConfig from './address.fields';

@Component({
  selector: 'lbca-address',
  templateUrl: './address.component.html',
  styleUrl: './address.component.scss',
  imports: [
    InputTextComponent,
    InputRadioComponent,
    SelectComponent,
    IconComponent,
    ButtonComponent,
  ],
})
export class AddressComponent implements OnInit {
  public isRequired: boolean = false;
  public isDisabled: boolean = false;

  public prepareDelete: boolean = false;

  public confirmDelete: boolean = false;

  public hasError: boolean = false;
  public isValid: boolean = false;
  public isLabeled: boolean = true;

  public isTouched: boolean = false;

  public dataAddress = {
    index: '',
    street: '',
    city: '',
    state: '',
    neighborhood: '',
    cep: '',
    complement: '',
    number: '',
    type: '',
  };

  public dataErrors: any = {
    index: [],
    street: [],
    city: [],
    state: [],
    neighborhood: [],
    cep: [],
    complement: [],
    number: [],
    type: [],
  };

  public fields = FieldsConfig;

  @Output('validateCallback') validateCallbackEmitter = new EventEmitter();

  @Output('changeData') changeEmiter = new EventEmitter();
  @Output('delete') deleteEmmiter = new EventEmitter();

  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = value;
  }
  @Input() displayFields!: { [key: string]: boolean };

  @Input('data')
  set value(val: any) {
    if (val) {
      val.cep = val.zip ? val.zip : val.cep ? val.cep : '';
      this.dataAddress = val;
    }
  }

  ngOnInit(): void {
    this.validateCallbackEmitter.emit(this.validationCallback);
  }

  public validationCallback = () => {
    if (this.isRequired) {
      Object.keys(FieldsConfig).forEach((key: string) => {
        if ((FieldsConfig as any)[key].require) {
          if ((this.dataAddress as any)[key] == '') {
            this.dataErrors[key] = ['Campo Obrigatório!'];
          }
        }
      });
    }
  };

  public prepareDeleteAddress() {
    this.prepareDelete = !this.prepareDelete;
  }

  public async deleteAddress(dataAddress) {
    this.confirmDelete = true;
    await waitingTimer(700);
    this.deleteEmmiter.emit(dataAddress);
  }

  public setValue(key, value) {
    this.dataErrors[key] = [];
    if (key == 'cep' && value != this.dataAddress.cep) this.getPromise(value);
    (this.dataAddress as any)[key] = value;
    this.changeEmiter.emit(this.dataAddress);
  }

  private getPromise(cep) {
    if (cep.length == 8) {
      cepPromise(cep, {
        timeout: 5000,
      })
        .then((resp) => {
          this.dataAddress.city = resp.city;
          this.dataAddress.neighborhood = resp.neighborhood;
          this.dataAddress.state = resp.state;
          this.dataAddress.street = resp.street;
          this.dataErrors.city = [];
          this.dataErrors.neighborhood = [];
          this.dataErrors.state = [];
          this.dataErrors.street = [];
        })
        .catch(() => {
          this.dataErrors.cep = ['O cep é inválido'] as any;
        });
    }
  }
}
